<template>
    <div class='v-footer'>
        <div class='content'>
            <div class='top_box'>
                <div class="logo pointer" @click="$router.push({name:'home'})">
                    <img class="index_logo" :src="logo" alt="">
                </div>
                <div class="top_center">
                    <div class='call' :class="{callActive:aboutIndex === index && showIndex}"
                         v-for="(item,index) in about_as" :key='index'
                         @click="toAbout(index)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="top_right">
                    <img class="phone_img" src="../assets/images/footerPhone.png" alt="">
                    <div class="phone_box">
                        <a>{{ kfrxName }}：{{ kfrx }}</a><br>
                        <a>{{ swhzName }}：{{ swhz }}</a>
                    </div>
                </div>

            </div>
            <div class="hezuo">
                <div class="hezuo_left">
                    <div class="yqlj_name">
                        {{yqlj_name}}
                    </div>
                    <div class="hezuo_box">
                        <a v-for="(item,index) in yqlj" target="_blank" :key="index" :href="item[1]">{{ item[0]}}</a>
                    </div>
                </div>
                <div class="hezuo_right">
                    <img :src="indexQrcode" alt="">
                    <div class='Promp'>扫一扫&nbsp;&nbsp;立即关注</div>
                </div>

            </div>
            <div class="first bottom">
                <span>{{ bqsmName }}: </span><span>{{ bqsm }}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ icpKey }}: </span>
                <span>{{ icp }}</span></div>
            <div class="company bottom">          </div>
        </div>
    </div>
</template>

<script>
	import {getConfig} from "../api";

	export default {

		data() {
			return {
				yqlj_name: '',
				yqlj: [],
				bqsmName: '',
				bqsm: '',
				icpKey: "",
				icp: '',
				kfrxName: '',
				kfrx: '',
				swhzName: '',
				swhz: '',
				indexQrcode: '',
				about_as: '',
				aboutIndex: '',
				showIndex: false,
				index_logo: '',
				logo: ''
			}
		},
		computed: {},
		created() {
			this.init()
			this.logo = localStorage.getItem('logo')
			this.aboutIndex = Number(localStorage.getItem('aboutIndex'));
			window.addEventListener('setItem', () => {
				// console.log(localStorage.getItem('dealId'))
				this.aboutIndex = Number(localStorage.getItem('aboutIndex'));
			})
			// console.log(this.aboutIndex)
		},
		mounted() {
			this.about()
			// this.$store.dispatch('GetConfig');
		},
		methods: {
			init() {
				getConfig().then(res => {
					// console.log(res)
					this.yqlj = res.data[25].value
					this.yqlj_name = res.data[24].value
					this.bqsmName = res.data[5].name
					this.bqsm = res.data[5].value
					this.icpKey = res.data[3].name
					this.icp = res.data[3].value
					this.kfrxName = res.data[1].name
					this.kfrx = res.data[1].value
					this.swhzName = res.data[2].name
					this.swhz = res.data[2].value
					this.indexQrcode = res.data[9].value
					// this.index_logo = res.data[6].value
					// localStorage.setItem('meta_title', res.data[0].value)
					// localStorage.setItem('kfrx', res.data[1].value)
					// localStorage.setItem('kfrxName', res.data[1].name)
					// localStorage.setItem('swhz', res.data[2].value)
					// localStorage.setItem('swhzName', res.data[2].name)
					// localStorage.setItem('icp', res.data[3].value)
					// localStorage.setItem('icpName', res.data[3].name)
					// localStorage.setItem('gawba', res.data[4].value)
					// localStorage.setItem('bqsm', res.data[5].value)
					// localStorage.setItem('bqsmName', res.data[5].name)
					// localStorage.setItem('index_logo', res.data[6].value)
					// localStorage.setItem('index_footer', res.data[7].value)
					// localStorage.setItem('index_header', res.data[8].value)
					// localStorage.setItem('index_qrcode', res.data[9].value)
					// localStorage.setItem('gzsj', res.data[15].value)
					// localStorage.setItem('sf_phone', res.data[16].value)
					// localStorage.setItem('zf_phone', res.data[17].value)
					// localStorage.setItem('erweima', res.data[18].value)
					// localStorage.setItem('QQ', res.data[19].value)
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			about() {
				this.$api.getSysArticleList({
					type: '关于我们'
				}).then(res => {
					// console.log(res)
					this.about_as = res.data
				}).catch(err => {
					this.$message({
						message: err.msg,
					})
				})
			},
			toAbout(index) {
				this.$addStorageEvent('aboutIndex', index)
				this.$router.push('/aboutUs/' + index)
			}

		},
		watch: {
			$route(path) {
				// console.log(path)
				if (path.name === 'aboutUs') {
					this.showIndex = true
				}
				else this.showIndex = false
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    /* 公用 */
    .v-footer {
        background: #393A3F;
        .content {
            width: 1200px;
            min-width: 1200px;
            /*display: flex;*/
            /*justify-content: space-between;*/
            font-size: 14px;
            color: #fff;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            margin: 0 auto;
            padding: 30px 0;
            .logo {
                width: 130px;
                height: 48px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                .index_logo {
                    width: 100%;
                }
            }
            a {
                color: #fff;
            }
            .top_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                /*border-bottom: 1px solid #fff;*/
                .top_center {
                    flex: 1;
                    display: flex;
                    margin-left: 98px;

                    .call {
                        margin-right: 20px;
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #fff;
                        line-height: 22px;
                        cursor: pointer;
                    }

                    .callActive {
                        color: #FFAE01;
                    }
                }

                .top_right {
                    display: flex;
                    align-items: center;

                    .phone_box {
                        margin-left: 10px;
                        font-size: 18px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #fff;
                        line-height: 25px;

                        .phone_img {
                            width: 51px;
                            height: 45px;
                            display: block;
                        }
                    }

                }
            }

            .hezuo {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                margin-top: 20px;
                padding: 29px 28px 30px 54px;
                border-top: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
                .hezuo_left {
                    .yqlj_name {
                        font-size: 24px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        line-height: 25px;
                        padding-bottom: 20px;
                    }
                    .hezuo_box {
                        display: flex;
                        flex-wrap: wrap;
                        a {
                            font-size: 18px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            line-height: 25px;
                            padding: 0 60px 30px 0;
                        }
                    }
                }

                .hezuo_right {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img {
                        margin: 0 0 6px;
                    }
                }
            }

            .bottom {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 25px;
            }

            .first {
                display: flex;
                justify-content: center;
                padding: 19px 0 14px;
            }
            .company {
                text-align: center;
            }
        }
    }


</style>


